import { Component, inject, Input, OnDestroy, OnInit, signal } from "@angular/core";
import { map, Subject } from "rxjs";
import { BetPlacementService } from "../../../../../../../../shared/src/lib/services/bet-placement.service";
import { DecimalPipe, NgClass } from "@angular/common";
import { safeParseFloat } from "../../../../../../../../shared/src/lib/utils/common";
import { MarketData } from "../../../../../../../../shared/src/lib/types/market.type";
import { AsianHandicapService } from "../../../../../../../../shared/src/lib/services/asian-handicap.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-asian-handicap-pnl",
  imports: [DecimalPipe, NgClass],
  templateUrl: "./asian-handicap-pnl.component.html",
  styleUrl: "./asian-handicap-pnl.component.scss",
})
export class AsianHandicapPnlComponent implements OnInit, OnDestroy {
  @Input({ required: true }) market!: MarketData;
  readonly destroy$ = new Subject<void>();
  placementService = inject(BetPlacementService);
  combinedPnLs = signal<any[]>([]);
  protected readonly Array = Array;

  constructor(private readonly asianHandicapService: AsianHandicapService) {}

  ngOnInit() {
    this.getMarketBets();
    // console.log(this.hcpRanges);
  }

  get runners() {
    // console.log(this.market);
    const runner1 = this.market?.runners?.[0] ?? {};
    const runner2 = this.market?.runners?.[1] ?? {};
    return [runner1, runner2];
  }

  get isAsianHandicap() {
    return ["Handicap", "Asian Handicap"].includes(this.market?.marketName);
  }

  get marketId() {
    return this.market?.marketId;
  }

  get hcpRanges() {
    const handicaps = this.market?.runners?.map((runner) => runner.handicap);
    const minRange = Math.floor(Math.min(...handicaps));
    const maxRange = Math.ceil(Math.max(...handicaps));
    const isAsianHandicap = handicaps?.some((h) => h < 0);
    return {
      min: isAsianHandicap ? minRange - 1 : minRange,
      max: isAsianHandicap ? maxRange + 1 : maxRange,
      baseGoal: isAsianHandicap ? 0 : minRange,
      pnlLength: isAsianHandicap ? maxRange + 1 : maxRange - minRange + 1,
    };
  }

  getMarketBets() {
    this.placementService.openBetsSubject
      .pipe(
        map((bets) => {
          return bets.filter((bet: any) => bet.marketId === this.market?.marketId && safeParseFloat(bet?.stakeRemaining) === 0);
        }),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.combinedPnLs.set([]);

          if (this.isAsianHandicap) {
            this.determineACHPnL(data);
          } else {
            this.determineGLPnL(data);
          }
        },
      });
  }

  determineACHPnL(bets: any[]) {
    this.combinedPnLs.set(this.asianHandicapService.determineACHPnL(this.market, bets));
  }

  determineGLPnL(bets: any[]) {
    this.combinedPnLs.set(this.asianHandicapService.determineGLPnL(this.market, bets));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
